<template>
  <div class="d-flex flex-space-between">
    <b-form-input
      class="w-45"
      :type="inputType"
      placeholder="From"
      v-model="filterInputFrom"
    />
    <b-form-input
      class="w-45"
      :type="inputType"
      placeholder="To"
      v-model="filterInputTo"
    />
  </div>
</template>

<script>
export default {
  props: {
    inputType: {
      type: String,
      default: 'number',
    },
    value: {},
    valueType: {},
  },
  data: () => ({
    filterInputFrom: null,
    filterInputTo: null,
  }),
  created() {
    this.filterInputFrom = this.value
      ? JSON.parse(this.value)[`${this.valueType}_from`] || ''
      : '';
    this.filterInputTo = this.value
      ? JSON.parse(this.value)[`${this.valueType}_to`] || ''
      : '';
  },
  watch: {
    filterInputFrom(val) {
      if (!val) {
        if (this.filterInputTo) {
          this.$emit(
            'input',
            JSON.stringify({ [`${this.valueType}_to`]: this.filterInputTo }),
          );
        } else {
          this.$emit('input', null);
        }
      } else {
        if (this.filterInputTo) {
          this.$emit(
            'input',
            JSON.stringify({
              [`${this.valueType}_from`]: val,
              [`${this.valueType}_to`]: this.filterInputTo,
            }),
          );
        } else {
          this.$emit(
            'input',
            JSON.stringify({ [`${this.valueType}_from`]: val }),
          );
        }
      }
    },
    filterInputTo(val) {
      if (!val) {
        if (this.filterInputFrom) {
          this.$emit(
            'input',
            JSON.stringify({
              [`${this.valueType}_from`]: this.filterInputFrom,
            }),
          );
        } else {
          this.$emit('input', null);
        }
      } else {
        if (this.filterInputFrom) {
          this.$emit(
            'input',
            JSON.stringify({
              [`${this.valueType}_from`]: this.filterInputFrom,
              [`${this.valueType}_to`]: val,
            }),
          );
        } else {
          this.$emit(
            'input',
            JSON.stringify({ [`${this.valueType}_to`]: val }),
          );
        }
      }
    },
  },
};
</script>

<style></style>
